(function() {
    class TeaserTiles {
        constructor() {
            this.activityData = {};
            this.lastsearchData = {};
            this.tilesContainer = document.querySelector('.div24TeaserTilesDynamic');
            this.tilesLoading = this.tilesContainer.querySelectorAll('.loading');
            this.teaserContainer = document.querySelector('.c24m-teaser-container');

            this.initTracking();
            this.addChatbotFlowToTiles();

            const activityTilesHeadline = this.tilesContainer.querySelector('.c24ActivityHeadline');
            const activityTilesWrapper = this.tilesContainer.querySelector('.cssTabContentBox.c24ActivityWrapper');
            const activityTileTemplate = this.tilesContainer.querySelector('.template.c24ActivityTile');

            const lastSearchTilesHeadline = this.tilesContainer.querySelector('.c24LastSearchHeadline');
            const lastSearchTilesWrapper = this.tilesContainer.querySelector('.cssTabContentBox.c24LastSearchWrapper');
            const lastSearchTileTemplate = this.tilesContainer.querySelector('.template.c24LastSearchTile');

            this.tilesTemplates = {
                activityData: {
                    headline: activityTilesHeadline,
                    container: activityTilesWrapper,
                    template: activityTileTemplate,
                },
                lastSearch: {
                    headline: lastSearchTilesHeadline,
                    container: lastSearchTilesWrapper,
                    template: lastSearchTileTemplate,
                },
            };
            // Use this to prioritize the tiles by product key
            this.prioritizedProductKeys = {
                submitDataTiles: [],
                activityTiles: [],
                lastSearchTiles: [],
            };

            this.teaserLayout = {
                loggedIn: {
                    onActivitiTilesLoading: {
                        classes: ['loggedIn'],
                        elements: ['greetingsContainer', 'skeletonSliderContainer'],
                    },
                    withActivityTiles: {
                        classes: ['loggedIn', 'withActivityTiles'],
                        elements: [
                            'greetingsContainer',
                            'dynamicTilesContainer',
                            'recommendedProductsHeadline',
                            'recommendedProductsContainer',
                        ],
                    },
                    withoutActivityTiles: {
                        classes: ['loggedIn', 'withoutActivityTiles'],
                        elements: [
                            'greetingsContainer',
                            'blurredMask',
                            'recommendedProductsContainer',
                            'dynamicTilesContainer',
                        ],
                    },
                },
                loggedOut: {
                    classes: [],
                    elements: [
                        'teasersSlider',
                        'blurredMask',
                        'recommendedProductsContainer',
                        'dynamicTilesContainer',
                    ],
                },
            };

            this.teaserLayoutElements = this.getTeaserLayoutElements();

            this.loadTileData();
        }
        initTracking() {
            document.addEventListener('loadTilesEvent', function() {
                const options = {
                    root: null,
                    rootMargin: '0px',
                    threshold: 1.0,
                };

                setTimeout(function() {
                    const oaTileCallback = window.c24Lp.createTileCallback('oa-tile:show', [
                        'prefix',
                        'position',
                        'ppset',
                        'type',
                    ]);
                    const lsTileCallback = window.c24Lp.createTileCallback('ls-tile:show', [
                        'prefix',
                        'position',
                        'ppset',
                        'type',
                    ]);
                    window.c24Lp.setupTileObserver(oaTileCallback, '.c24ActivityTile:not(.c24Hidden)', options);
                    window.c24Lp.setupTileObserver(lsTileCallback, '.c24LastSearchTile:not(.c24Hidden)', options);
                    const dataAttributes = [
                        'prefix',
                        'position',
                        'ppset',
                        'type',
                    ];

                    window.c24Lp.createClickTracking('.c24ActivityTile', dataAttributes, 'oa-tile');
                    window.c24Lp.createClickTracking('.c24LastSearchTile', dataAttributes, 'ls-tile');
                }, 1);
            });
        }
        loadTileData() {
            const activityDataPromise = this.getTiles(
                this.activityData,
                'api/?k=24&a=getactivitytiles'
                + '&deviceoutput=' + window.c24LpDeviceOutput
                + '&timeout=' + this.getTimeout(),
            );

            const lastsearchDataPromise = this.getTiles(
                this.lastsearchData,
                'api/?k=24&a=getlastsearchtiles'
                + '&deviceoutput=' + window.c24LpDeviceOutput
                + '&timeout=' + this.getTimeout(),
            );

            this.changeLayoutDependingOnLogin();

            Promise.allSettled([activityDataPromise, lastsearchDataPromise]).finally(() => {
                this.renderTiles();
                const loadTilesEvent = new CustomEvent('loadTilesEvent', {});
                document.dispatchEvent(loadTilesEvent);
                if (this.lastsearchData?.status === 408) {
                    this.secondLoad();
                }
                this.changeLayoutDependingOnLogin(false);

            });
        }
        getTeaserLayoutElements() {
            if (!this.teaserContainer) {
                return;
            }
            const teasersSlider = this.teaserContainer.querySelector('.c24m-home-slides-container');
            const skeletonSliderContainer = this.teaserContainer.querySelector('.c24-skeleton-slider-container');
            if (skeletonSliderContainer) {
                const skeletonSlider = skeletonSliderContainer.querySelector('.c24-skeleton-slider');
                if (skeletonSlider) {
                    skeletonSliderContainer.appendChild(skeletonSlider.cloneNode(true));
                }
            }
            const dynamicTilesContainer = this.teaserContainer.querySelector('.div24TeaserTilesDynamic');
            const recommendedProductsContainer = this.teaserContainer.querySelector('.c24m-tiles-container');
            const blurredMask = this.teaserContainer.querySelector('.c24m-slider-blurred-mask');
            const greetingsContainer = this.teaserContainer.querySelector('.c24-greetings-container');
            const recommendedProductsHeadline = this.teaserContainer.querySelector('.c24-tiles-container-headline');
            return {
                teasersSlider,
                skeletonSliderContainer,
                dynamicTilesContainer,
                recommendedProductsContainer,
                blurredMask,
                greetingsContainer,
                recommendedProductsHeadline,
            };
        }

        applyLayoutClasses(layoutConfig) {
            [
                'loggedIn',
                'withActivityTiles',
                'withoutActivityTiles',
            ].forEach(className => {
                this.teaserContainer.classList.remove(className);
            });

            layoutConfig.classes.forEach(className => {
                this.teaserContainer.classList.add(className);
            });
        }

        addLayoutElements(layoutConfig) {
            layoutConfig.elements.forEach(elementId => {
                const element = this.teaserLayoutElements[elementId];
                if (element) {
                    element.classList.remove('c24Hidden');
                    this.teaserContainer.appendChild(element);
                }
            });
        }

        changeLayoutDependingOnLogin(beforeAllPromises = true) {
            if (!this.teaserContainer) {
                return;
            }
            while (this.teaserContainer.firstChild) {
                this.teaserContainer.removeChild(this.teaserContainer.firstChild);
            }
            if (window.c24IsLoggedIn) {
                if (beforeAllPromises) {
                    const layoutConfig = this.teaserLayout.loggedIn.onActivitiTilesLoading;
                    this.applyLayoutClasses(layoutConfig);
                    this.addLayoutElements(layoutConfig);
                } else {
                    this.changeLayoutDependingOnActivityTiles();
                }
            } else {
                const layoutConfig = this.teaserLayout.loggedOut;
                this.applyLayoutClasses(layoutConfig);
                this.addLayoutElements(layoutConfig);
            }
        }
        changeLayoutDependingOnActivityTiles() {
            const activityTilesNumber = this.activityData?.activityTiles?.length || 0;
            const submitDataTilesNumber = this.activityData?.submitDataTiles?.length || 0;
            const hasActivityTiles = activityTilesNumber + submitDataTilesNumber > 0;
            const layoutKey = hasActivityTiles ? 'withActivityTiles' : 'withoutActivityTiles';
            const layoutConfig = this.teaserLayout.loggedIn[layoutKey];
            this.applyLayoutClasses(layoutConfig);
            this.addLayoutElements(layoutConfig);
        }
        getTimeout() {
            if (!window.c24LpIsProduction) {
                return 5;
            }
            return 3;
        }
        getTiles(data, query) {
            const timeoutMs = this.getTimeout() * 1000 * 2;
            return $.ajax({
                type: 'GET',
                url: window.c24LpRoot + query,
                dataType: 'json',
                timeout: timeoutMs,
                async: true,
            }).done(function(json) {
                Object.assign(data, json);
            }).catch((error) => {
                window.c24Lp.logError('Failed to retrieve mobile tiles', {
                    url: window.c24LpRoot + query,
                    error: {
                        status: error.status,
                        statusText: error.statusText,
                        responseText: error.responseText,
                        message: error.message,
                    },
                    trace: error.trace,
                    deviceOutput: window.c24LpDeviceOutput,
                    timeoutMs: timeoutMs,
                });
            });
        }
        getLastsearchPpsetIds() {
            const lastsearchPpsetIds = [];
            for (const lastSearchesItem of this.lastsearchData?.lastSearchTiles ?? []) {
                lastsearchPpsetIds.push(lastSearchesItem.productKey);
            }
            return lastsearchPpsetIds;
        }
        renderTiles() {
            this.resetAllTiles();
            this.renderActivityTiles(this.activityData);
            this.renderLastSearchTiles(this.lastsearchData);

            const appPromo = this.tilesContainer.querySelector('.c24m-fallback-app-banner');
            if (appPromo) {
                if (
                    !this.isEmptyObject(this.activityData?.submitDataTiles)
                    || !this.isEmptyObject(this.activityData?.activityTiles)
                    || this.lastsearchData?.lastSearchTiles?.length > 0
                ) {
                    appPromo.classList.add('c24Hidden');
                } else {
                    appPromo.classList.remove('c24Hidden');
                }
            }
            this.hideLoadingTiles();
        }
        isEmptyObject(obj) {
            if (obj === null || typeof obj !== 'object') {
                return true;
            }

            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    return false;
                }
            }

            return true;
        }
        secondLoad() {
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'tile:secondLoad',
            ]);
        }
        lazyLoadTooltipText(apiUrl, setTextCallback) {
            let xhr = new XMLHttpRequest();
            xhr.onload = function () {
                if (xhr.readyState !== 4) {
                    return;
                }
                let data = JSON.parse(xhr.responseText);
                if (xhr.status !== 200 || !data.data?.label) {
                    return;
                }

                setTextCallback(data.data.label);
            };

            xhr.open('GET', apiUrl, true);
            xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xhr.send();
        }
        renderActivityTile(item, tile, type, index) {
            const tileWrapper = tile.querySelector('.c24SubmitData');
            const tileStatus = tile.querySelector('.status');
            const tileTooltipText = tile.querySelector('.tooltipText');
            const tileHeadline = tile.querySelector('.productName');
            const tileImg = document.createElement('img');
            const tileDetailLine1 = tile.querySelector('.detailLine1');
            const tileDetailLine2 = tile.querySelector('.detailLine2');
            const tileDetailLine3 = tile.querySelector('.detailLine3');
            const tileCta = tile.querySelector('.cta');
            const tilePrice = tile.querySelector('.tariffPrice');
            const tilePeriod = tile.querySelector('.tariffPeriod');

            const itemProductKey = item.productKey;
            const itemHeadline = item.headline;
            const itemTileUrl = (type === 'dn') ? item.ctaUrl : item.tileUrl;
            const itemImageUrl = item.imageUrl;
            const itemDetailLine1 = item.detailLine1;
            const itemDetailLine2 = item.detailLine2;
            const itemDetailLine3 = item.detailLine3;
            const itemActivityStatusText = item.activityStatusText;
            const itemActivityStatus = item.activityStatus;
            const itemTariffPeriod = item.tariff?.period;
            const itemTariffPrice = item.tariff?.price;
            const itemCtaText = item.ctaText;
            const itemCtaUrl = item.ctaUrl;
            const itemTooltipText = item.tooltipText;
            const itemCase = item.case;

            tileHeadline.innerHTML = itemHeadline;
            tileWrapper.href = itemTileUrl;

            tileImg.className = 'insuranceIcon';

            if (itemImageUrl) {
                tileImg.src = itemImageUrl;
            } else {
                tileImg.style.display = 'none';
            }

            if (itemProductKey === 'vermop') {
                if (itemCase === 'renewal') {
                    tileDetailLine1.innerText = window.c24.lp.activities.mpdv.getCoverageLabel(itemDetailLine1);
                    tileDetailLine2.innerText = window.c24.lp.activities.mpdv.getVehicleLabel(itemDetailLine2);
                    tileDetailLine3.innerText = itemDetailLine3;
                } else {
                    tileDetailLine1.innerText = itemDetailLine1;
                    tileDetailLine2.innerText = itemDetailLine2;
                    tileDetailLine3.remove();
                }
            } else if (itemProductKey === 'veresc') {
                if (itemCase === 'renewal') {
                    tileDetailLine1.innerText = window.c24.lp.activities.mpdv.getCoverageLabel(itemDetailLine1);
                    tileDetailLine2.innerText = itemDetailLine2;
                } else {
                    tileDetailLine1.innerText = itemDetailLine1;
                    tileDetailLine2.innerText = itemDetailLine2;
                }
                tileDetailLine3.remove();
            } else {
                if (itemDetailLine1) {
                    tileDetailLine1.innerText = itemDetailLine1;
                } else {
                    tileDetailLine1.remove();
                }

                if (itemDetailLine2) {
                    tileDetailLine2.innerText = itemDetailLine2;
                } else {
                    tileDetailLine2.remove();
                }

                if (itemDetailLine3) {
                    tileDetailLine3.innerText = itemDetailLine3;
                } else {
                    tileDetailLine3.remove();
                }
            }

            if (itemActivityStatusText) {
                tileStatus.innerText = itemActivityStatusText;
            } else {
                tileStatus.remove();
            }

            if (itemActivityStatus && itemActivityStatusText) {
                tileStatus.classList.add(itemProductKey);
                tileStatus.classList.add(itemActivityStatus);
            }

            if (itemTariffPeriod && itemTariffPrice) {
                tilePeriod.innerHTML = itemTariffPeriod;
                tilePrice.innerHTML = itemTariffPrice;
            } else {
                tilePrice.innerHTML = '\u00A0';
            }

            tileCta.innerHTML = itemCtaText;

            if (itemCtaUrl) {
                tileCta.onclick = function(e) {
                    e.preventDefault();
                    window.location.href = itemCtaUrl;
                };
            }

            tile.setAttribute('data-type', type);
            tile.setAttribute('data-ppset', itemProductKey);
            tile.setAttribute('data-position', index);

            tile.querySelector('.insuranceIcon').replaceWith(tileImg);

            function setTooltipText(text) {
                tileTooltipText.innerHTML = text;
            }

            if (itemTooltipText) {
                setTooltipText(itemTooltipText);
            }

            tile.classList.add(itemProductKey);
            tile.classList.add(type);

            tileWrapper.classList.remove('c24Hidden');
        }
        renderLastSearchTile(item, tile, index) {
            const wrapper = tile.querySelector('.c24LastSearch');
            const headline = tile.querySelector('.productName');
            const iconContainer = tile.querySelector('.iconContainer');
            const fittingTariffs = tile.querySelector('.fittingTariffsContainer');
            const insuredObject = tile.querySelector('.insuredObject');
            const status = tile.querySelector('.status');
            const tariffPeriod = tile.querySelector('.tariffPeriod');
            const tariffPrice = tile.querySelector('.tariffPrice');
            const tariffPricePrefix = tile.querySelector('.tariffPricePrefix');

            wrapper.href = item.item_link;
            headline.innerHTML = item.productName;
            iconContainer.style.backgroundImage = `url('${window.c24LpRoot}images/tiles/lastsearches/${item.productKey}.svg')`;
            fittingTariffs.innerHTML = item.partial2;
            insuredObject.innerHTML = item.partial1;

            if (!item.partial1) {
                insuredObject.remove();
            }

            if (!item.partial2) {
                fittingTariffs.remove();
            }

            status.innerHTML = this.getLastLineWording(item.timestamp);
            const {
                price, period, prefix,
            } = this.getTariffDetails(item);
            tariffPrice.innerHTML = price;

            if (period) {
                tariffPeriod.innerHTML = period;
            } else {
                tariffPeriod.remove();
            }

            if (prefix) {
                tariffPricePrefix.innerHTML = prefix + ' ';
            } else {
                tariffPricePrefix.remove();
            }

            tile.setAttribute('data-type', 'ls');
            tile.setAttribute('data-ppset', item.productKey);
            tile.setAttribute('data-position', index);
        }
        hideLoadingTiles() {
            for (const tile of this.tilesLoading) {
                tile.classList.add('c24Hidden');
            }
        }
        resetAllTiles() {
            const activityTiles = this.tilesTemplates.activityData.container.querySelectorAll('.c24ActivityTile:not(.template)');
            const lastSearchTiles = this.tilesTemplates.lastSearch.container.querySelectorAll('.c24LastSearchTile:not(.template)');

            for (const tile of [...activityTiles, ...lastSearchTiles]) {
                tile.remove();
            }
        }
        cloneAndAppendTemplate(type) {
            let clonedTemplate;

            if (type === 'activity') {
                clonedTemplate = this.tilesTemplates.activityData.template.cloneNode(true);
            } else if (type === 'lastSearch') {
                clonedTemplate = this.tilesTemplates.lastSearch.template.cloneNode(true);
            } else {
                return null;
            }

            clonedTemplate.classList.remove('template', 'c24Hidden');

            if (type === 'activity') {
                this.tilesTemplates.activityData.container.appendChild(clonedTemplate);
            } else if (type === 'lastSearch') {
                this.tilesTemplates.lastSearch.container.appendChild(clonedTemplate);
            }

            return clonedTemplate;
        }
        getTariffDetails(item) {
            const price = item.price + ' ' + item.price_suffix;
            const regex = /\bbis\b|\bab\b/i;
            const itemPricePrefix = item.price_prefix;
            const itemPrefixMatch = itemPricePrefix.match(regex);
            const pricePrefix = itemPrefixMatch ? itemPrefixMatch[0] : '';
            const pricePeriod = itemPricePrefix.replace(regex, '').trim();
            return {
                prefix: pricePrefix,
                price: price,
                period: pricePeriod,
            };
        }
        renderHeadline(headline, tileCount, singular, plural) {
            headline.innerHTML = (tileCount < 2 ? singular : plural) + ' (' + tileCount + ')';
        }
        sortTilesByProductKey(tiles, prioritizedProductKeys) {
            return tiles.sort((a, b) => {
                let aIndex = prioritizedProductKeys.indexOf(a.productKey);
                let bIndex = prioritizedProductKeys.indexOf(b.productKey);
                if (aIndex === -1) {
                    aIndex = prioritizedProductKeys.length;
                }
                if (bIndex === -1) {
                    bIndex = prioritizedProductKeys.length;
                }
                return aIndex - bIndex;
            });
        }
        setSortedTiles(json, type) {
            const prioritizedProductKeys = this.prioritizedProductKeys[type] || [];
            if (prioritizedProductKeys.length > 0) {
                return this.sortTilesByProductKey(json, prioritizedProductKeys);
            }
            return json;
        }
        renderActivityTiles(json) {
            let activityIndex = 1;
            if (!this.isEmptyObject(json?.submitDataTiles)) {
                const sortedSubmitDataTiles = this.setSortedTiles(json.submitDataTiles, 'submitDataTiles');
                for (const submitDataItem of sortedSubmitDataTiles) {
                    const submitDataTile = this.cloneAndAppendTemplate('activity');
                    this.renderActivityTile(submitDataItem, submitDataTile, 'dn', activityIndex++);
                    this.tilesTemplates.activityData.headline.classList.remove('c24Hidden');
                    this.tilesTemplates.activityData.container.classList.remove('c24Hidden');
                }
            }

            if (!this.isEmptyObject(json?.activityTiles)) {
                const sortedActivityTiles = this.setSortedTiles(json.activityTiles, 'activityTiles');
                for (const activityItem of sortedActivityTiles) {
                    const submitDataTile = this.cloneAndAppendTemplate('activity');
                    this.renderActivityTile(activityItem, submitDataTile, 'ws', activityIndex++);
                    this.tilesTemplates.activityData.headline.classList.remove('c24Hidden');
                    this.tilesTemplates.activityData.container.classList.remove('c24Hidden');
                }
            }

            this.renderHeadline(this.tilesTemplates.activityData.headline, (activityIndex - 1), 'offene Aufgabe', 'offene Aufgaben');

            if (activityIndex === 1) { // no tiles have been added
                this.tilesTemplates.activityData.headline.classList.add('c24Hidden');
                this.tilesTemplates.activityData.container.classList.add('c24Hidden');
            }
        }
        renderLastSearchTiles(json) {
            let lastSearchIndex = 1;
            if (json?.lastSearchTiles?.length > 0) {
                const sortedLastSearchTiles = this.setSortedTiles(json.lastSearchTiles, 'lastSearchTiles');
                for (const lastSearchItem of sortedLastSearchTiles) {
                    const lastSearchTile = this.cloneAndAppendTemplate('lastSearch');
                    this.renderLastSearchTile(lastSearchItem, lastSearchTile, lastSearchIndex++);
                }

                this.renderHeadline(this.tilesTemplates.lastSearch.headline, json.lastSearchTiles.length, 'Vergleich', 'Vergleiche');

                this.tilesTemplates.lastSearch.headline.classList.remove('c24Hidden');
                this.tilesTemplates.lastSearch.container.classList.remove('c24Hidden');
            } else {
                this.tilesTemplates.lastSearch.headline.classList.add('c24Hidden');
                this.tilesTemplates.lastSearch.container.classList.add('c24Hidden');
            }
        }
        getLastLineWording(timestamp) {
            let date = new Date(timestamp * 1000);
            let dateWording = 'Vergleich vom ' + date.toLocaleDateString('de-DE');
            let today = new Date();
            let dateDiff = Math.round((today.getTime() - date.getTime()) / (1000 * 3600 * 24));

            if (dateDiff < 1) {
                return 'Vergleich von heute';
            }
            if (dateDiff >= 1 && dateDiff < 2) {
                return 'Vergleich von gestern';
            }

            return dateWording;
        }
        addChatbotFlowToTiles() {
            const tiles = document.querySelectorAll('.c24m-tile');
            for (const tile of tiles) {
                const flowName = tile.dataset.flowName;
                const flowEntry = tile.dataset.flowEntry;
                if (tile.dataset.flowActive && flowName && flowEntry) {
                    window.c24LpAddChatbotElement({
                        chatFlowName: flowName,
                        chatFlowEntry: flowEntry,
                    }, tile);

                    tile.onclick = function(e) {
                        e.preventDefault();
                    };
                }
            }
        }
    }

    window.c24DomReady(function() {
        if (document.querySelector('.div24TeaserTilesDynamic .loading')) {
            new TeaserTiles();
        }
    });
})();
